import React, { Component } from 'react';
import { AnchorLink } from 'gatsby-plugin-anchor-links';

class Hero extends Component {
  componentDidMount() {
    const btn = document.getElementById('menu-btn');
    const closeBtn = document.getElementById('close-btn');
    const menu = document.getElementById('menu');

    btn?.addEventListener('click', navToggle);
    closeBtn?.addEventListener('click', navToggle);

    function navToggle() {
      btn?.classList.toggle('open');
      menu?.classList.toggle('flex');
      menu?.classList.toggle('hidden');
    }
  }

  render() {
    return (
      <section id='hero'>
        <div className='container max-w-7xl px-6 py-12 mx-auto'>
          {/* Menu/Logo Container */}
          <nav className='flex items-center justify-between font-bold text-[var(--custom-black)]'>
            {/* Logo */}
            <div className='flex items-center justify-between space-x-3 text-2xl font-bold md:text-3xl'>
              <img src={'/cheqrboard-logo.svg'} alt='' />
              <b className='cheqrboard'>CheQRboard</b>
            </div>

            {/* Menu */}
            <div className='md:visible invisible h-10 md:flex md:space-x-8 md:justify-center md:items-center'>
              <a
                href='https://share.hsforms.com/1vQT5Dh5IQg6q5d23tBcocwr7uug'
                rel='noopener'
                target='_blank'
                className='demo py-2 px-10 border border-[#333215] rounded-3xl duration-150 hover:bg-[#333215] hover:text-white'
              >
                <span className='relative'>Request a Demo</span>
              </a>
            </div>

            {/* Hamburger Button */}
            <div className='md:hidden'>
              <button
                id='menu-btn'
                type='button'
                title='Menu'
                className='z-40 block hamburger md:hidden focus:outline-none'
              >
                <span className='hamburger-top'></span>
                <span className='hamburger-middle'></span>
                <span className='hamburger-bottom'></span>
              </button>
            </div>
          </nav>

          {/* Mobile Menu */}
          <div
            id='menu'
            className='absolute top-0 bottom-0 left-0 flex-col self-end hidden w-full min-h-screen py-1 pt-40 space-y-3 text-lg text-white uppercase bg-[var(--custom-black)]'
          >
            <div className='relative flex flex-col w-1/2 -top-24 mx-auto py-4 px-6 rounded'>
              <AnchorLink
                to='/#content-platform'
                title='Content Management'
                className='hover:text-[var(--color-secondary)] text-center'
                stripHash
              />
            </div>
            <div className='relative flex flex-col w-1/2 -top-24 mx-auto py-4 px-6 rounded'>
              <AnchorLink
                to='/#analytics' 
                title='Analytics' 
                className='hover:text-[var(--color-secondary)] text-center'
                stripHash
              />
            </div>
            <div className='relative flex flex-col w-1/2 -top-24 mx-auto py-4 px-6 rounded'>
              <AnchorLink
                to='/#contact-us'
                title='Contact Us'
                className='hover:text-[var(--color-secondary)] text-center'
                stripHash
              />
            </div>
            <div className='relative flex flex-col w-1/2 -top-24 mx-auto border py-4 px-6 rounded bg-[#fafafa] text-[#333215] shadow-2xl'>
              <button
                id='close-btn'
                type='button'
                title='Close'
                className='uppercase font-semibold'
              >
                Close
              </button>
            </div>
          </div>

          {/* Hero Section */}
          <div className='flex flex-col items-center justify-between mt-10 space-x-4 md:flex-row'>
            {/* Text Container */}
            <div className='flex flex-col items-center justify-between'>
              {/* Heading */}
              <div className='max-w-2xl p-4 mt-0 md:mt-10 text-5xl font-semibold leading-[3.25rem] text-center text-[#333215] md:my-2 md:text-6xl md:text-left'>
                Boost Guest Engagement with QR-Powered Experiences
              </div>
              <div className='max-w-lg p-4 text-lg text-center md:my-2 md:text-2xl md:text-left md:self-start'>
                Fueled by a stunningly simple <span className='font-semibold'>content management system— </span> designed to enhance your guest education, empower your messaging, and propel your mission forward
              </div>

              {/* Request Demo Button */}
              <a
                href='https://share.hsforms.com/1vQT5Dh5IQg6q5d23tBcocwr7uug'
                rel='noopener'
                target='_blank'
                className='demo flex flex-row rounded-full bg-[#333215] text-[#fafafa] py-5 px-12 items-center my-6 text-xl md:self-start duration-150 hover:bg-[#fafafa] hover:text-[#333215] hover:font-semibold hover:shadow-lg'
              >
                <span className='leading-6'>Request a Demo</span>
              </a>

              {/* Icons */}
              <div className='flex flex-row items-start justify-center w-full my-6 space-x-10 md:space-x-36 md:justify-start'>
                <div className='flex space-x-2'>
                  <img
                    className='relative w-12 h-12'
                    alt=''
                    src={'/customized-content.svg'}
                  />

                  <div className='relative leading-6'>
                    <p className='m-0'>Content</p>
                    <p className='m-0'>Creation</p>
                  </div>
                </div>

                <div className='flex space-x-2'>
                  <img
                    className='relative w-12 h-12'
                    alt=''
                    src={'/multilingual-translation.svg'}
                  />
                  <div className='relative ml-2 leading-6'>
                    <p className='m-0'>Multilingual</p>
                    <p className='m-0'>Translation</p>
                  </div>
                </div>
              </div>
              <div className='flex flex-row items-start justify-center w-full my-6 md:justify-start'>
                <div className='flex space-x-2'>
                  <img
                    className='relative w-12 h-12'
                    alt=''
                    src={'/multimedia-templates.svg'}
                  />

                  <div className='relative leading-6 !mr-[2rem] md:!mr-[7.8rem]'>
                    <p className='m-0'>Multimedia</p>
                    <p className='m-0'>Templates</p>
                  </div>
                </div>

                <div className='flex space-x-2'>
                  <img
                    className='relative w-12 h-12'
                    alt=''
                    src={'/engagement-analytics.svg'}
                  />
                  <div className='relative ml-2 leading-6'>
                    <p className='m-0'>Engagement</p>
                    <p className='m-0'>Analytics</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Image Container */}
            <div className='hidden !visible md:block md:flex flex-col'>
              <img
                className='max-h-96 md:max-h-[30rem] relative bottom-[-5rem]'
                alt=''
                src={'/new-hero-image.svg'}
              />

              <div className='relative z-10 right-[7rem] bottom-[1rem] md:bottom-[10rem] w-[20rem]'>
                <div className='flex justify-center items-center'>
                  <img
                    className='relative md:w-[95%] w-[45%]'
                    alt=''
                    src={'/new-qr-code-icon.svg'}
                  />
                </div>
              </div>
            </div>
            {/* Image Container Mobile View*/}
            <div className='block md:hidden md:!visible flex justify-center items-center !m-0'>
              <img
                className='relative w-full'
                alt=''
                src={'/new-qr-code-icon.svg'}
              />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Hero;
